// Environment resolution + URL validation for the Supabase client, split out
// from lib/supabase.ts so that reading the *config* (does .env have what we
// need?) does not pull in `@supabase/supabase-js`.
//
// main.tsx imports `isSupabaseConfigured` from here to render the
// "Konfigurationsfel" screen before anything else. If that import reached
// lib/supabase.ts, the whole ~210 kB Supabase bundle (GoTrue + realtime +
// storage + postgrest) would land in the entry chunk and be modulepreloaded
// on every visit — including the public landing page, which never talks to
// Supabase before first paint. Keeping this module dependency-free lets the
// client itself load only inside the lazy route/guard chunks that use it.

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Supabase itself never serves a plaintext endpoint (see
// docs/implementation-guide.md §15.1), but nothing upstream stops
// VITE_SUPABASE_URL from being misconfigured as http:// — it's just a string
// baked in at build time. Fail closed instead of silently sending the anon
// key, and every subsequent request, over plaintext. Bare localhost/127.0.0.1
// is allowed over http since that's a local `supabase start` stack whose
// traffic never leaves the machine.
export const isSecureSupabaseUrl = (url: string): boolean => {
  if (!url) return false;
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'https:') return true;
    return parsed.protocol === 'http:' && (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1');
  } catch {
    return false;
  }
};

export const isSupabaseConfigured = !!(
  supabaseUrl &&
  supabaseAnonKey &&
  isSecureSupabaseUrl(supabaseUrl)
);
